import React from 'react';

interface DashboardCardsProps {
  dossier: any;
  metrics: any;
  stats: any;
  commonCategories: any;
}

const getMetricColor = (key: string) => {
  switch (key) {
    case 'newInconsistencies': return '#ef4444';
    case 'resolved': return '#22c55e';
    case 'inReview': return '#eab308';
    case 'highSeverityOpen': return '#a855f7';
    case 'needsAssignment': return '#3b82f6';
    default: return '#94a3b8';
  }
};

const DashboardCards: React.FC<DashboardCardsProps> = ({ dossier, metrics, stats, commonCategories }) => {
  return (
    <div className="cg-cards-layout">
      {/* Left Column: Dossier Card */}
      <div className="cg-dossier-card">
        <div>
          <div className="cg-dossier-header">
            <h3>{dossier.name}</h3>
          </div>
          <p className="cg-dossier-owner">Owner: {dossier.owner}</p>
          <p className="cg-dossier-count">{dossier.inconsistenciesCount} inconsistencies</p>
        </div>
        <div className="cg-dossier-progress">
          <div 
            className="cg-progress-circle-large" 
            style={{ '--progress': `${dossier.resolvedPercentage}%` } as React.CSSProperties}
          >
            <div className="cg-progress-inner-large">
              {dossier.resolvedPercentage}%
            </div>
          </div>
        </div>
      </div>
      
      {/* Right Column: Metrics Section */}
      <div className="cg-metrics-section">
        <div className="cg-metrics-top-actions">
          <div className="cg-last-month-dropdown">
            <select className="cg-last-month-select">
              <option>Last month</option>
              <option>Last 30 Days</option>
              <option>Last Quarter</option>
              <option>Year to Date</option>
              <option>All Time</option>
            </select>
            <div className="cg-last-month-arrow">
              <svg width="8" height="5" viewBox="0 0 8 5" fill="none"><path d="M1 1L4 4L7 1" stroke="#64748B" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>
            </div>
          </div>
        </div>

        <div className="cg-metrics-grid-top">
          {Object.entries(metrics).map(([key, metric]: [string, any]) => (
            <div key={key} className="cg-metric-card">
              <div className="cg-metric-header">
                <div className="cg-metric-icon">
                  {key === 'lastScan' ? (
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#64748b" strokeWidth="2"><circle cx="12" cy="12" r="10"/><path d="M12 6v6l4 2"/></svg>
                  ) : (
                    <div className="cg-metric-dot" style={{ backgroundColor: getMetricColor(key) }}></div>
                  )}
                </div>
                <div className="cg-metric-label">{metric.label}</div>
              </div>
              <div className="cg-metric-value">{metric.value}</div>
              <div className="cg-metric-subtext">{metric.subtext}</div>
            </div>
          ))}
        </div>
        
        <div className="cg-metrics-grid-bottom">
          <div className="cg-bottom-card">
            <div className="cg-bottom-card-header">Avg. time to resolve</div>
            <div className="cg-bottom-card-body">
              <div className="cg-bottom-value">{stats.averageTimeToResolve}</div>
              <svg viewBox="0 0 100 30" className="cg-sparkline" preserveAspectRatio="none">
                <path d="M0,20 L40,20 L70,12 L100,22" stroke="#3b82f6" strokeWidth="1.5" fill="none" vectorEffect="non-scaling-stroke"/>
              </svg>
            </div>
          </div>

          <div className="cg-bottom-card">
            <div className="cg-bottom-card-header">Resolution rate</div>
            <div className="cg-bottom-card-body">
              <div className="cg-bottom-value">{stats.resolutionRate}</div>
              <svg viewBox="0 0 100 30" className="cg-sparkline" preserveAspectRatio="none">
                <path d="M0,25 L30,25 L70,18 L100,12" stroke="#3b82f6" strokeWidth="1.5" fill="none" vectorEffect="non-scaling-stroke"/>
              </svg>
            </div>
          </div>

          <div className="cg-bottom-card cg-categories-card">
            <div className="cg-bottom-card-header" style={{ marginBottom: 0 }}>Most common<br/>categories</div>
            <div className="cg-categories-list">
              {commonCategories.map((c: any, i: number) => (
                <div key={i} className="cg-category-line">
                  {i + 1}. {c.category} ({c.count})
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardCards;
